<script setup>
import { ref, watch } from "vue";

const emit = defineEmits(["search"]);

defineProps({
  icon: {
    type: String,
    default: "fa fa-search",
  },
  name: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "input-search-simplified",
  },
  placeholder: {
    type: String,
    default: "Buscar...",
  },
  width: {
    type: String,
    default: "250px",
  }
});

const searchText = ref("");

watch(searchText, (newValue) => {
  emit("search", newValue);
});

function clearSearch() {
  searchText.value = "";
}
</script>

<template>
  <div
    class="searcher-simplified d-flex border align-items-center ps-2"
    :style="{ width }"
  >
    <div class="col-auto p-0">
      <i :class="icon"></i>
    </div>
    <input
      :id="id"
      v-model="searchText"
      :name="name"
      :placeholder="placeholder"
      type="input"
      class="simplified-input border-0 mt-1"
    />
    <div v-if="searchText" class="col-auto p-0 me-2">
      <i class="fa fa-times cursor-pointer" @click="clearSearch"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.searcher-simplified {
  border-radius: 0.5rem;
  min-height: unset;
  background-color: white;
  display: flex;
  align-items: center;
}

.simplified-input {
  outline: none;
  flex: 1;
  margin-left: 8px;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  height: 100%;
}

.cursor-pointer {
  cursor: pointer;
}
</style>